export default function siteImproveLoader($rootScope) {
    var obj = this;

    obj.scriptID = "siteanalyze_259887";

    obj.cookieComplianceCollector = function () {
        $rootScope.$broadcast("add-cookies-to-model", { cookies: obj.cookies });
    };
    /***
     * List of cookies Provided by Siteimprove
     */
    obj.cookies = [
        {
            name: "nmstat",
            issuer: "Siteimprove",
            purpose:
                "This cookie contains an ID string on the current session. This contains non-personal information on what subpages the visitor enters – this information is used to optimize the visitor's experience.",
            expirery: "999 dage",
            type: "http",
            storageType: "cookie",
            category: "statistics",
        },
        {
            name: "__cfduid",
            issuer: "Siteimprove",
            purpose:
                "Used by the content network, Cloudflare, to identify trusted web traffic.",
            expirery: "29 dage",
            type: "http",
            storageType: "cookie",
            category: "statistics",
        },
        {
            name: "siteimproveses",
            issuer: "Siteimprove",
            purpose:
                "Registers statistical data on visitors' behaviour on the website. Used for internal analytics by the website operator.",
            expirery: "Session",
            type: "http",
            storageType: "cookie",
            category: "statistics",
        },
        {
            name: "AWSELB",
            issuer: "Siteimprove",
            purpose:
                "Used to distribute traffic to the website on several servers in order to optimise response times.",
            expirery: "Session",
            type: "http",
            storageType: "cookie",
            category: "statistics",
        },
    ];

    obj.injectScript = function () {
        var tags = document.getElementsByTagName("script");
        let elem = tags[obj.scriptID];

        if (elem) {
            return false;
        }

        var sz = document.createElement("script");
        sz.type = "text/javascript";
        sz.async = true;
        sz.id = obj.scriptID;
        sz.src = "//siteimproveanalytics.com/js/siteanalyze_259887.js";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(sz, s);

        // DONE
        console.info("added Siteimprove");
    };

    obj.destroyScript = function () {
        var tags = document.getElementsByTagName("script");
        let elem = tags[obj.scriptID];

        if (!elem) {
            return false;
        }
        elem.parentNode.removeChild(elem);
        console.info("remove Siteimprove");
    };

    obj.cookieComplianceCollector();

    return obj;
}
